module.exports = __webpack_public_path__ + "static/media/white_rook.d3c88173.svg";